module.exports = __webpack_public_path__ + "static/media/error.6f9d87b6.png";